import moment from 'moment';
import * as eh from '../helpers/event-helper';
import { saveExcel } from '../helpers/excel';
import { DATE_FORMAT_DASHED, TIME_FORMAT } from '../helpers/dates';

export function getReportName() {
  return `TJM_${moment().format('YYYYMMDD')}_Report`;
}

export function getTjmReportData(events) {
  return events.map(event => {
    const { outbound, inbound } = event;

    let delayTime = '-';
    const delay = outbound.ATD
      ? eh.calculateDelayTime(event.STD, outbound.ATD)[2]
      : 0;
    const isDelayed = delay >= 60000; // 1 min
    if (isDelayed) {
      const seconds = delay / 1000;
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      delayTime = `${hours ? `${hours} ч ` : ''}${minutes} мин`;
    }

    let fullName = '-';
    if (event.allocatedStaff[0]) {
      const { firstName, lastName } = event.allocatedStaff[0].user;
      fullName = `${lastName} ${firstName[0]}.`;
    }

    let delayServices = '-';
    if (isDelayed) {
      delayServices = '';
      if (outbound.delaysServices?.drinks?.amount) {
        delayServices += '+ПН';
      }

      if (outbound.delaysServices?.hotMeals?.amount) {
        delayServices += '+ГП';
      }

      if (
        outbound.delaysServices?.hotel?.paxNo ||
        outbound.delaysServices?.hotel?.amount
      ) {
        delayServices += '+Гостиница';
      }

      delayServices = delayServices.slice(1);
      delayServices = delayServices || 'не предоставлялось';
    }

    let notes = outbound.postFlightNotes
      .map(note => note.description.trim())
      .filter(description => description)
      .reduce((result, description) => `${result}${description},\n`, '');
    notes = notes.trim().slice(0, -1) || '-';

    return [
      moment(event.STD).format(DATE_FORMAT_DASHED), // Дата
      `${event.airline} ${event.outboundNumber}`, // А/К. № рейса
      `${event.airport} - ${event.outboundAirport}`, // Маршрут
      outbound.aircraftReg, // № ВС
      outbound.aircraftType, // Тип ВС
      moment(event.STA).format(TIME_FORMAT), // t прил. План
      inbound.ATA ? moment(inbound.ATA).format(TIME_FORMAT) : '-', // t прил. Факт
      moment(event.STD).format(TIME_FORMAT), // t вылет. План
      outbound.ATD ? moment(outbound.ATD).format(TIME_FORMAT) : '-', // t вылет. Факт
      delayTime, // t задержки
      eh.getTotalAdultsCount(outbound.actualPaxLoad) ?? 0, // Пасс. ВЗР
      eh.getTotalChildrenCount(outbound.actualPaxLoad) ?? 0, // РБ
      eh.getTotalInfantCount(outbound.actualPaxLoad) ?? 0, // РМ
      eh.getTotalPaxLoadByClass(outbound.actualPaxLoad, 'business') ?? 0, // Бизнес
      eh.getTotalBagsWeight(outbound.actualPaxLoad) ?? 0, // Багаж кг
      outbound.excessBaggage?.totalMcoEmd ?? 0, // Плат. Бг.
      eh.getTotalCargoWeight(outbound.cargo) ?? 0, // Груз
      0, // Почта
      outbound.delays.length
        ? outbound.delays
            .reduce((result, delay) => `${result}/${delay.code || ''}`, '')
            .slice(1)
        : '-', // Код задержки
      delayServices, // УСЛУГИ по задержке
      notes, // Примечания по рейсу
      fullName, // Представитель
    ];
  });
}

export function createTjmReport(events) {
  const data = getTjmReportData(events);
  const columnNames = [
    'Дата', // 17-3-2022
    'А/К. № рейса', // DP 592
    'Маршрут', // TJM - VKO
    '№ ВС', // RA73273
    'Тип ВС', // B738
    't прил. План', // 4:10
    't прил. Факт', // 4:10
    't вылет. План', // 4:10
    't вылет. Факт', // 4:10
    't задержки', // 25 мин or -
    'Пасс. ВЗР',
    'РБ',
    'РМ',
    'Бизнес',
    'Багаж кг',
    'Плат. Бг.',
    'Груз',
    'Почта',
    'Код задержки', // 93/94
    'УСЛУГИ по задержке', // - or не предоставлялись or ПН + ГП
    'Примечания по рейсу',
    'Представитель', // Иванов А. С.
  ];
  const styles = {
    header: {
      font: {
        bold: true,
      },
      alignment: { horizontal: 'center' },
    },
    text: {
      alignment: {
        horizontal: 'center',
        vertical: 'center',
        wrapText: true,
      },
    },
    number: {
      alignment: {
        horizontal: 'center',
        vertical: 'center',
      },
    },
  };
  return saveExcel({
    fileName: getReportName(),
    columnNames,
    styles,
    data,
    frozenColumns: 3,
    frozenRows: 1,
  });
}
